import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'

const router = createRouter({
	history: createWebHistory("/"),
	routes: [
	
		{
			path: '/car',
			name: '车辆检测',
			component: () => import('../views/car.vue')
		},
		{
			path: '/carDetails',
			name: '套餐详情',
			component: () => import('../views/carDetails.vue')
		},
		{
			path: '/carList',
			name: '车辆列表',
			component: () => import('../views/carList.vue')
		},
	],
})


router.beforeEach((to, from, next) => {
	document.title = to.name || '默认标题';
	// //拦截跳转机构版 https://yi.suyuanbd.cn
 if (to.path === '/' ) {
		next(`/carList`)
	}
	else {
		next()
	}
})


export default router